var Curriculog = Curriculog || {};

Curriculog.UserRoleListView = (function ($, _, Backbone, UserRoleListView) {

	UserRoleListView = Curriculog.ItemListView.extend({
		template: 'HierarchyList/userRoleList.html',

		initialize: function (options) {
			this.items = options.items;
			this.userID = options.userID;
			this.entity = options.entity;
			this.committee = options.committee;
      this.params = options.params;
			this.render();
		},

		render: function () {
			// sort items by role name
			this.items.sort(function(a, b) {
				if (a['name'].toLowerCase() < b['name'].toLowerCase())
					return -1;
				if (a['name'].toLowerCase() > b['name'].toLowerCase())
					return 1;
				else return 0;
			})

			templateVars = {
				items: this.items,
				userID: this.userID,
        cui_enabled: this.params.cui_enabled
			}
			var el = nunjucks.render(this.template, templateVars);
			this.replaceElement(el);
		},
	});
	return UserRoleListView;

})($, _, Backbone, Curriculog.UserRoleListView || {});
